<template>
  <div class="stages-item" :style="styleObject" @click="$emit('click')">
    <div class="stages-item__image">
      <div class="stages-item__image-icon" v-if="icon">
        <component :is="icon"></component>
      </div>
      <slot name="image"></slot>
    </div>
    <div class="stages-item__description">
      <rwl-heading h="2" class="stages-item__heading">
        {{title}}
      </rwl-heading>
      <component :is="decoration" v-if="decoration" class="stages-item__decoration"></component>
      <slot name="description"></slot>
    </div>
  </div>
</template>

<script>
  import { RwlHeading } from "@rawlplug/rawlplug-design-components-library";

  export default {
    name: "StagesItem",
    components: { RwlHeading },
    props: {
      icon: {
        type: [Object, null],
      },
      decoration: {
        type: [Object, null]
      },
      title: {
        type: String
      },
      color: {
        type: String,
      }
    },
    computed: {
      styleObject: function() {
        return {
          '--color': 'transparent',
          '--color-hover': this.color
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .stages-item {
    position: relative;
    cursor: pointer;
    &__image {
      width: 100%;
      height: 230px;
      position: relative;
      overflow: hidden;

      svg {
        object-fit: cover;
        width: 100%;
        height: 100%;
      }

      &-icon {
        position: absolute;
        fill: $color-rwl-white-100;
        display: flex;
        justify-content: center;
        align-items: center;
        left: 24px;
        bottom: 24px;
        width: 132px;
        height: 132px;
        z-index: 3;
      }

      &::after {
        content: '';
        position: absolute;
        z-index: 2;
        left: 0;
        top: 0;
        width: 160%;
        height: 160%;
        transition: transform 300ms ease-in-out;
        background: linear-gradient(45deg, var(--color-hover) 0%, rgba(255,255,255,0) 60%, rgba(255,255,255,0) 100%);
      }
    }

    &__decoration {
      right: 20px;
      top: -20px;
      position: absolute;
      fill: $color-rwl-orange-100;
      z-index: 5;
      transition: transform ease-in-out 300ms;
    }

    &__description {
      position: relative;
      min-height: 160px;
      color: $color-text;
      font-size: $font-size-rwl-headline-6;
      line-height: $line-height-rwl-headline-6;
      font-weight: $font-weight-light;
      padding: $spacing-6 $spacing-5;
      background-color: transparent;
      transition: all ease-in-out 300ms;
    }

    .stages-item__heading.rwl-heading {
      transition: all ease-in-out 300ms;
      color: $color-text;
    }

    &:hover {
      .stages-item__description {
        background-color: var(--color-hover);
      }

      .stages-item__image {
        &::after {
          transform: translate(-100%, 100%);
        }
      }

      .stages-item__description {
        color: white;
      }

      .stages-item__heading {
        color: white;
      }

      .stages-item__decoration {
        transform: translateY(40px);
      }
    }


    @media (min-width: $breakpoint-sm-min) {
      &__description {
        padding: $spacing-5 0;
        font-size: $font-size-rwl-body;
        line-height: $line-height-rwl-body;
      }

      .stages-item__heading.rwl-heading {
        font-size: $font-size-rwl-headline-4;
        line-height: $line-height-rwl-headline-4;
      }
    }

    @media (min-width: $breakpoint-lg-min)  {

      &__description {
        padding: $spacing-6 $spacing-5;
        font-size: $font-size-rwl-headline-6;
        line-height: $line-height-rwl-headline-6;
        min-height: 170px;
      }

      .stages-item__heading.rwl-heading {
        font-size: $font-size-rwl-headline-3;
      }
    }
  }
</style>
